import { useHistory } from 'react-router-dom'
export const EditWarehouseUpdate = () => {
    const history = useHistory()
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">

                                <div className="mb-3 col-6">
                                    <label className="form-label">Job No.</label>
                                    <input
                                       
                                        className='form-control'
                                        placeholder="Enter Job No. "
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Customer Name</label>
                                    <input
                                       
                                        className='form-control'
                                        placeholder="Enter Customer Name "
                                    />

                                </div>
                            </div>

                            <div className="row">

                                <div className="mb-3 col-6">
                                    <label className="form-label">Customer Contact No.</label>
                                    <input
                                       
                                        className='form-control'
                                        placeholder="Add Customer Contact No"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Retailer Contact No.</label>
                                    <input
                                       
                                        className='form-control'
                                        placeholder="Add Retailer Contact No.r"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Booking Cargo Details</label>
                                    <input
                                       
                                        className='form-control'
                                        placeholder="Add Booking Cargo Details"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Warehouse Cargo Details</label>
                                    <input
                                       
                                        className='form-control'
                                        placeholder="Add Warehouse Cargo Detailsr"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Comments</label>
                                    <textarea
                                       
                                        className='form-control'
                                        placeholder="Add Comments"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label"> Repacking Charges</label>
                                    <textarea
                                       
                                        className='form-control'
                                        placeholder="Add Repacking Charges"
                                    />
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => console.log("fdgfdg")}
                                >Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
